import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService, Departamento } from '../../api.service';

@Injectable({ providedIn: 'root' })
export class ServicoDepartamentoAdministrativo {
  constructor(private readonly api: ApiService) {}

  novoDepartamento(empregadorId = ''): Departamento {
    return {
      empregadorId,
      nome: '',
      ativo: true
    };
  }

  rotuloDepartamento(departamento: Departamento): string {
    return departamento.ativo ? departamento.nome : `${departamento.nome} (inativo)`;
  }

  prepararEdicao(departamento: Departamento | undefined, empregadorId: string): Departamento {
    return departamento ? { ...departamento, empregadorId: departamento.empregadorId || empregadorId } : this.novoDepartamento(empregadorId);
  }

  listarPorEmpregadorSelecionado(empregadorId: string, incluirInativos = false): Observable<Departamento[]> {
    if (!empregadorId) {
      return of([]);
    }
    return this.api.listarDepartamentos(empregadorId, incluirInativos);
  }

  salvar(departamento: Departamento): Observable<Departamento> {
    return this.api.salvarDepartamento(departamento);
  }

  excluir(id: string): Observable<void> {
    return this.api.excluirDepartamento(id);
  }
}
